import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template7.css";
import "./CheckoutTemplate7.css";

/*
   Checkout Template 7 — a seamless continuation of sales Template 7
   ("Spotlight Noir", premium dark). Reuses Template7.css directly (same
   .clp7-root design system): the real .g7-nav, the dark .g7-hero band, the
   .g7-title with its animated .g7-grad accent, the .g7-btn.g7-btn-p button
   and .g7-foot footer. Only the form + order summary cards are checkout-
   specific (CheckoutTemplate7.css), styled to match the template's dark
   .g7-card look and --cl-* tokens.
*/
export default function ThankYouTemplate7({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp7-root">
      {/* NAV — same as the sales page */}
      <nav className="g7-nav scr">
        <div className="g7-wrap g7-nav-in">
          <span className="g7-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok7-brandtext">{c.brand}</span>}
          </span>
          <span className="cok7-secure">✓ Order confirmed</span>
        </div>
      </nav>

      {/* HERO — reuses the sales hero band + animated gradient accent title */}
      <header className="g7-hero cok7-hero">
        <div className="g7-wrap">
          <div className="cok7-hero-in">
            <span className="g7-eyebrow cok7-eyebrow">Thank you</span>
            <h1 className="g7-title">
              You're <span className="g7-grad">enrolled</span>
            </h1>
            {c.sub ? <p className="g7-sub cok7-sub">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's dark card style */}
      <div className="g7-wrap">
        <ThankYouBody data={data} p="cok7" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="g7-foot">
        <div className="g7-wrap g7-foot-in">
          <div className="cok7-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
